import { css, SerializedStyles } from '@emotion/core';
import { Theme, normalText, titleText } from 'features/Theme';

const styles = {
  titleText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
    text-align: center;
  `,
  subtitleText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
    text-align: center;
  `,
  normalText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    text-align: center;
    color: ${theme.mui.palette.text.secondary};
  `,
};

export default styles;
